module.exports = __webpack_public_path__ + "static/logo-figma.bdafcb3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-figma.png
// module id = 447
// module chunks = 35783957827783